import { HvacModes } from '@vae/server/dist/interfaces/eNode/eNodeHVAC.interface'
import dayjs from 'dayjs'
import React, { useContext, useEffect, useState } from 'react'
import { useTranslation } from 'react-i18next'
import { logEvent } from '../../../../analytics/utils/firebaseUtils'
import ModeSwitch from '../../../../components/ModeSwitch'
import { HvacContext } from '../HvacContext'

const Controls = () => {
	const { hvac, setHvacValue, setModeSwitchLoading, actionStatus, modeSwitchLoading } =
		useContext(HvacContext)
	const [selectedMode, setSelectedMode] = useState<string | null | undefined>(null)
	useEffect(() => {
		setSelectedMode(hvac?.thermostatState.mode)
	}, [hvac])

	const { t } = useTranslation('pages_hvac')

	const handleClick = (mode: HvacModes) => {
		logEvent('click-hvac-change-mode')
		setModeSwitchLoading(true)

		setTimeout(() => {
			setHvacValue(hvac?.id ?? '', {
				...hvac?.thermostatState,
				mode,
				heatSetpoint: hvac?.thermostatState.heatSetpoint || 21,
				coolSetpoint: hvac?.thermostatState.coolSetpoint || 21,
			})
			setSelectedMode(mode)
		}, 4000) // 4000 seconds
	}

	return (
		<div className='controls flex flex-col gap-4' id='Toggle'>
			<ModeSwitch
				customBackground='bg-[#f5f5f5] dark:bg-[#144448]'
				options={
					hvac?.capabilities.capableModes
						?.filter(mode => mode !== 'AUTO')
						.map(mode => ({
							mode: mode as HvacModes,
							label:
								mode === 'HEAT' ? t('modeHeat') : mode === 'COOL' ? t('modeCool') : t('modeOff'),
						})) || []
				}
				currentMode={selectedMode as HvacModes}
				onModeChange={handleClick}
				disabled={actionStatus?.state === 'PENDING' || modeSwitchLoading}
			/>

			<div className='info text-gray-700 dark:text-gray-200 flex flex-col gap-3 pt-4 border-t border-gray-100 dark:border-gray-600'>
				<div className='updated flex justify-between items-center text-sm'>
					<span className='text-gray-600 dark:text-gray-400'>{t('lastUpdated')}</span>
					<span className='font-medium text-gray-800 dark:text-white'>
						{dayjs(hvac?.lastSeen).format('HH:mm')}
					</span>
				</div>
				<div className='disclaimer text-center text-xs text-gray-500 dark:text-gray-400 leading-relaxed'>
					{t('disclaimer')}
				</div>
			</div>
		</div>
	)
}

export default Controls
